export enum EttachedHiddenType {
  HIDDEN = 'HIDDEN',
  ATTACHED = 'ATTACHED',
}
